import React from 'react'
import tw, { styled } from 'twin.macro'
import parse from 'html-react-parser'
import { motion } from 'framer-motion'
import { useStateContext } from '../context/stateContext'
import content from '../data/content.json'

const Container = styled(motion.div)`
	${tw``}
`
const Wrap = styled.div`
	${tw`relative flex flex-col items-center justify-between h-full px-4 md:px-6 py-5 mx-auto gap-10`}
`
const Headline = styled.h1`
	${tw`mb-4 sm:mb-8 text-2xl font-extrabold text-center text-yellow xs:text-3xl mobile:text-4xl md:text-7xl`}
`
const Description = styled.p`
	${tw`mb-4 sm:mb-8 text-xl text-center text-white`}
`
const ButtonWrap = styled.div`
	${tw`grid justify-center gap-3 mt-5`}
`
const InputField = styled.input`
	${tw`border border-gray-200 h-14 flex items-center px-5 bg-transparent text-white min-w-[280px]`}
`
const HighScore = styled.div`
	${tw`flex flex-col items-center w-11/12 md:w-3/4 gap-5 gap-y-0 sm:gap-y-3 mx-auto my-5 !text-white`}

	.alltimehs {
		${tw`pr-5 w-full`}
		::-webkit-scrollbar {
			width: 3px;
		}
		::-webkit-scrollbar-track {
			background: #101010;
			width: 3px;
		}
		::-webkit-scrollbar-thumb {
			background: #f1fc00;
			border-radius: 0px;
			width: 3px;
		}
		::-webkit-scrollbar-thumb:hover {
			background: #101010;
		}
	}
`

const HighScores = ({ userScore }) => {
	const [userInput, setUserInput] = React.useState(true)
	const [submitMessageStatus, setSubmitMessageStatus] = React.useState()
	const [highscore, setHighscore] = React.useState([])
	const highscoreRef = React.useRef()

	const stateContext = useStateContext()
	const { locale } = stateContext.state
	const t = content.langs
	const { pairs, rounds } = userScore

	const getHighScore = () => {
		fetch('https://wpsk.hattenbergerpartner.de/memory/get_highscore.php', {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		})
			.then((response) => response.text().then((data) => JSON.parse(data)))
			.then((body) => {
				if (body.length === 0) window.localStorage.clear()
				setHighscore(body)
			})
			.catch((err) => {
				console.error(err)
			})
	}

	const submitHighScore = () => {
		const userName = document.querySelector('#nickname').value
		const userMail = document.querySelector('#email').value
		const data = {
			userName: userName,
			userScore: rounds,
			userMail: userMail,
		}

		if (!userName || !userMail) {
			setSubmitMessageStatus('Beide Felder sind erforderlich')
			return
		}

		setUserInput(false)

		fetch('https://wpsk.hattenbergerpartner.de/memory/submit_score.php', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(data),
		})
			.then((response) => response.text().then((data) => setSubmitMessageStatus(data)))
			.then((body) => {
				getHighScore()
			})
			.catch((err) => {
				console.error(err)
			})
	}

	const onRestartGame = async () => {
		stateContext.dispatch({ action: 'SET_GAME_STATUS', data: 'gameStart' })
		await new Promise((resolve) =>
			setTimeout(() => {
				return resolve()
			}, 600)
		)
		stateContext.dispatch({ action: 'RESET_GAME' })
	}

	React.useEffect(() => {
		getHighScore()
	}, [])

	return (
		<Container>
			<Wrap>
				{userInput && (
					<>
						<Headline>{parse(t[locale].endHeadline)}</Headline>

						<div className='flex flex-wrap gap-5 items-center justify-center'>
							<InputField type='text' id='nickname' name='nickname' placeholder='Enter your name' required />
							<InputField type='text' id='email' name='email' placeholder='Enter your E-Mail' required />
						</div>
						{submitMessageStatus && <Description className='!text-pink'>{submitMessageStatus}</Description>}
						<ButtonWrap>
							<button className='bg-pink text-white md:text-lg py-2 md:py-4 px-4 uppercase md:tracking-wider min-w-[180px] md:min-w-[240px]' onClick={() => submitHighScore()}>
								{t[locale].submitFormButton}
							</button>
						</ButtonWrap>
					</>
				)}
				{!userInput && (
					<HighScore>
						<Headline>{parse(t[locale].highScoreHeadline)}</Headline>
						{submitMessageStatus && <Description>{submitMessageStatus}</Description>}
						<div className='w-full sm:w-10/12 h-[160px]'>
							<div ref={highscoreRef} className='flex flex-col h-full col-span-2 gap-2 overflow-y-auto text-white alltimehs'>
								{highscore.length > 0 &&
									highscore.map((singleScore, index) => {
										return (
											<p key={`${singleScore.nick}-${index}`} className={`flex w-full ${index === 0 ? 'text-3xl text-yellow' : 'text-xl'}`}>
												<span>{index + 1}.</span>
												<span className='pl-3 sm:pl-5'>{singleScore.nick}</span>
												<span className='ml-auto font-bold uppercase'>
													{singleScore.score} {singleScore.score === '1' ? t[locale].rounds[0] : t[locale].rounds[1]}
												</span>
											</p>
										)
									})}
							</div>
						</div>
						<ButtonWrap>
							<button className='bg-pink text-white md:text-lg py-2 md:py-4 px-4 uppercase md:tracking-wider min-w-[180px] md:min-w-[240px]' onClick={() => onRestartGame()}>
								{t[locale].endRestartButton}
							</button>
						</ButtonWrap>
					</HighScore>
				)}
			</Wrap>
		</Container>
	)
}

export default HighScores
